import { ApiEpNotification } from "@smp/api";
import { Await } from "@smp/utils";
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";

const KEY = "ep.notification.notification";

export const useEpNotification = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiEpNotification.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const queryClient = useQueryClient();

  const {
    data: notificationList,
    error: notificationListError,
    isLoading: isNotificationListLoading,
  } = useQuery(KEY, () => ApiEpNotification.list(), options?.useQueryOptions);

  const { mutate: notificationDestroy } = useMutation(
    ApiEpNotification.destroy,
    {
      onSuccess: () => {
        notificationIvalidate();
      },
    },
  );

  const notificationIvalidate = (...params: any[]) =>
    queryClient.invalidateQueries([KEY, ...params]);

  return {
    isNotificationListLoading,
    notificationDestroy,
    notificationIvalidate,
    notificationList,
    notificationListError,
  };
};
